import React, { useEffect, useState } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './BottomSlider.css';

const BottomSlider = ({ webContent, isLoading }) => {
  const [sliderItems, setSliderItems] = useState([]);

  const staticSliderItems = [
    { text: '24/7 Support' },
    { text: 'Activity Stream' },
    { text: 'Live Chat' },
    { text: 'Modern UI' },
    { text: 'Manage your task easily' }
  ];

  useEffect(() => {
    const dynamicData =
      webContent?.dataset?.data?.['features-list']?.json_data?.feature_titles;

    if (!isLoading && dynamicData && typeof dynamicData === 'object') {
      // Convert object to array by extracting values
      const dynamicArray = Object.values(dynamicData);
      if (dynamicArray.length > 0) {
        setSliderItems(dynamicArray.map((item) => ({ text: item.title })));
      } else {
        setSliderItems(staticSliderItems);
      }
    } else {
      setSliderItems(staticSliderItems);
    }
  }, [webContent, isLoading]);

  const settings = {
    dots: false,
    infinite: sliderItems.length > 5,
    speed: 2000,
    slidesToShow: Math.min(sliderItems.length, 5),
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    pauseOnHover: true,
    arrows: true,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: Math.min(sliderItems.length, 3),
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: Math.min(sliderItems.length, 2),
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };  

  const CustomPrevArrow = (props) => (
    <button {...props} className="slick-prev" style={{ left: '10px' }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="17" height="30" viewBox="0 0 17 30" fill="none">
        <path d="M14.4711 30C13.8284 30 13.1856 29.7546 12.6781 29.2287L0.735821 16.8536C-0.245274 15.837 -0.245274 14.1542 0.735821 13.1376L12.6781 0.762489C13.6592 -0.254163 15.2831 -0.254163 16.2642 0.762489C17.2453 1.77914 17.2453 3.46187 16.2642 4.47853L6.11493 14.9956L16.2642 25.5127C17.2453 26.5294 17.2453 28.2121 16.2642 29.2287C15.7905 29.7546 15.1478 30 14.4711 30Z" fill="#fff" />
      </svg>
    </button>
  );

  const CustomNextArrow = (props) => (
    <button {...props} className="slick-next" style={{ right: '10px' }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="17" height="30" viewBox="0 0 17 30" fill="none">
        <path d="M2.52885 30C3.17164 30 3.81443 29.7546 4.32189 29.2287L16.2642 16.8536C17.2453 15.837 17.2453 14.1542 16.2642 13.1376L4.32189 0.762489C3.3408 -0.254163 1.71691 -0.254163 0.735821 0.762489C-0.245275 1.77914 -0.245275 3.46187 0.735821 4.47853L10.8851 14.9956L0.735821 25.5127C-0.245275 26.5294 -0.245275 28.2121 0.735821 29.2287C1.20945 29.7546 1.85224 30 2.52885 30Z" fill="#fff" />
      </svg>
    </button>
  );

  return (
    <div className="bottom-slider-container">
      <Slider {...settings} prevArrow={<CustomPrevArrow />} nextArrow={<CustomNextArrow />}>
        {sliderItems.map((item, index) => (
          <div className="item" key={index}>
            <div className="slider-text">
              <span className="slider-dot">•</span>
              <span>{item.text}</span>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default BottomSlider;